// Funkce pro přidání množství po násobcích
function addQuantityByMultiples(el, min, max, multiples, step, action) {
    var $amountInput = $(el).closest('.quantity').find('.amount');
    var value = parseFloat($amountInput.val());
    if (isNaN(value)) {
        return false;
    }
    var min = parseFloat(min);
    var max = parseFloat(max);
    var multiples = parseFloat(multiples);
    var step = parseFloat(step)
    console.log('multiple - '+multiples)
    console.log('min - '+min)
    console.log('max - '+max)
    console.log(step)
    if (action === 'increase') {
        value += multiples;
    } else if (action === 'decrease') {
        value -= multiples;
    }
    if (value < min) {
        value = min;
    } else if (value > max) {
        value = max;
    }
    $amountInput.data('quantity', value);
    $amountInput.val(value)
    return true;
}
$('html').on('click', '.increase', function () {
    var min = $(this).closest('.quantity').find('.amount').attr('min');
    var max = $(this).closest('.quantity').find('.amount').attr('max');
    var step = $(this).closest('.quantity').find('.amount').attr('step');
    var multiples = min - step;
   // var multiples = min;
    addQuantityByMultiples(this, min, max, multiples, step, 'increase');
});

$('html').on('click', '.decrease', function () {
    var min = $(this).closest('.quantity').find('.amount').attr('min');
    var max = $(this).closest('.quantity').find('.amount').attr('max');
    var step = $(this).closest('.quantity').find('.amount').attr('step');
    var multiples = min - step;
    //var multiples = min;
    addQuantityByMultiples(this, min, max, multiples, step, 'decrease');
});



$(document).ready(function(){
$('.quantity input.amount').attr('readonly','true');
})


document.addEventListener('ShoptetDOMContentLoaded', function() {
    $('.quantity input.amount').attr('readonly','true');
})